module.exports = __webpack_public_path__ + "img/MapsList-Normal.767be29a.webp";